import { render, staticRenderFns } from "./Title2.vue?vue&type=template&id=4f57fb2c&scoped=true&"
import script from "./Title2.vue?vue&type=script&lang=js&"
export * from "./Title2.vue?vue&type=script&lang=js&"
import style0 from "./Title2.vue?vue&type=style&index=0&id=4f57fb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57fb2c",
  null
  
)

export default component.exports